var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-sidebar',{attrs:{"width":_vm.width + 'px',"id":_vm.id,"title":_vm.title,"right":_vm.right,"left":_vm.left,"shadow":"","backdrop":""},on:{"change":_vm.onChange}},[_c('div',{staticClass:"px-3 py-2"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }